import Backoffice from "@snark/backoffice"

// noinspection JSUnusedLocalSymbols
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	return new (P || (P = Promise))(function (resolve, reject) {
		function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
		function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
		function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
		step((generator = generator.apply(thisArg, _arguments || [])).next());
	});
};

const context = {
};

export default {
	name: "user",
	collection: "user",
	idProperty: "_id",
	section: "app",
	sort: {"back":[{"field":"lastname"},{"field":"firstname"},{"field":"email"}]},
	pagination: 50,
	backTextFilterList: true,
	viewActions: [
		{
			type: "logAs",
			logAs: {"field":"email"},
		},
	],
	backPopulateList: ["organization"],
	labels: {"singleTitle":"User","listTitle":"Users"},
	emptyItem: {"picture":{},"features":{}},
	fields: [
		{
			name: "firstname",
			label: "Firstname",
		},
		{
			name: "lastname",
			label: "Lastname",
		},
		{
			name: "_id",
			label: "Id",
			readOnly: true,
			hideOnCreate: true,
		},
		{
			name: "organizationId",
			label: "Organization Id",
		},
		{
			name: "organizationType",
			label: "Organization Type",
			formatter: Backoffice.formatters.mapping({"club": "Club", "agency": "Agency"}),
			editor: {type: "select", options: [{value: "club", label: "Club"}, {value: "agency", label: "Agency"}]},
		},
		{
			name: "email",
			label: "Email",
		},
		{
			name: "password",
			label: "Password",
			writeOnly: true,
		},
		{
			name: "picture",
			label: "Picture",
			children: [
				{
					name: "path",
					label: "Path",
				},
				{
					name: "thumbnail",
					label: "Thumbnail",
				},
				{
					name: "mimetype",
					label: "Mimetype",
				},
			],
		},
		{
			name: "role",
			label: "Role",
			formatter: Backoffice.formatters.mapping({"admin": "Admin", "member": "Member", "superadmin": "Superadmin"}),
			editor: {type: "select", options: [{value: "admin", label: "Admin"}, {value: "member", label: "Member"}, {value: "superadmin", label: "Superadmin"}]},
		},
		{
			name: "termsAccepted",
			label: "Terms Accepted",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "phone",
			label: "Phone",
		},
		{
			name: "marketingAccepted",
			label: "Marketing Accepted",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "fibaLicense",
			label: "Fiba License",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "federalLicense",
			label: "Federal License",
			formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
			editor: {type: "boolean", labels: ["Non", "Oui"]},
		},
		{
			name: "status",
			label: "Status",
			formatter: Backoffice.formatters.mapping({"waiting": "Waiting", "accepted": "Accepted"}),
			editor: {type: "select", options: [{value: "waiting", label: "Waiting"}, {value: "accepted", label: "Accepted"}]},
		},
		{
			name: "preferredLanguage",
			label: "Preferred Language",
		},
		{
			name: "features",
			label: "Features",
			children: [
				{
					name: "playerSimilarity",
					label: "Player Similarity",
					formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
					editor: {type: "boolean", labels: ["Non", "Oui"]},
				},
			],
		},
		{
			name: "state",
			label: "State",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.mapping({"deleted": "Deleted", "draft": "Draft"}),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "updatedAt",
			label: "Updated At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "token",
			label: "Token",
			readOnly: true,
		},
		{
			name: "tokenExpire",
			label: "Token Expire",
			readOnly: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
		{
			name: "resetToken",
			label: "Reset Token",
			readOnly: true,
		},
		{
			name: "resetTokenExpire",
			label: "Reset Token Expire",
			readOnly: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	listColumns: [
		{
			name: "organization",
			label: "Organization",
			formatter: Backoffice.formatters.subProperty("companyName"),
			nosingle: true,
		},
		{
			name: "email",
			label: "Email",
		},
		{
			name: "role",
			label: "Role",
			formatter: Backoffice.formatters.mapping({"admin": "Admin", "member": "Member", "superadmin": "Superadmin"}),
		},
		{
			name: "createdAt",
			label: "Created At",
			readOnly: true,
			hideOnCreate: true,
			formatter: Backoffice.formatters.date("DD/MM/YYYY"),
		},
	],
	loadSingle() {
		return Promise.all([
		]);
	},
};